export var DashboardSharingType;
(function (DashboardSharingType) {
    DashboardSharingType["Custom"] = "custom";
    DashboardSharingType["Organisation"] = "organisation";
    DashboardSharingType["UserOnly"] = "user_only";
})(DashboardSharingType || (DashboardSharingType = {}));
//# sourceMappingURL=dashboard-sharing-type.js.map